import styled from '@emotion/styled';
import { topRoundedCorners } from './RoundedCorners';
import overlay from './Palettes/overlay';

const CategoryHeading = styled.h2<{ jobOfTheWeek?: boolean }>`
  && {
    margin: 0;
    text-transform: uppercase;
    font-size: ${({ theme }) => theme.sizes.body1};
    color: ${overlay[900]};
    font-family: ${({ theme }) => theme.fonts.secondary};
    display: block;
    ${topRoundedCorners};

    ${({ jobOfTheWeek, theme }) => jobOfTheWeek && `
      && {
        color: #fff;
        background-color: ${theme.palette.primary.main};
        display: block;
        text-align: center;
        padding: 4px 12px;
      }
    `}
  }
`;

export default CategoryHeading;
